import { BaseKey, useShow } from "@refinedev/core"
import { ChildForm, ConfigCard } from "interfaces/schemaDB"
import { Typography, Tabs, Button, Modal } from 'antd';
import Cw8Edit from 'components/cw8/Cw8Edit';
import { MenuPublication } from "./MenuPublication";
import Cw8List from 'components/cw8/Cw8List';
import { Link } from "react-router-dom";
import { config } from "config";
import { useModalForm } from "@refinedev/antd";

interface EditPublicationsProps{
    resourceLabel ?: string
    resourceName :string
    id : BaseKey | undefined 
    childrenForms : ChildForm[]
}

export const EditPublications = ({ resourceLabel, resourceName, childrenForms, id }: EditPublicationsProps) => {
  const { Title } = Typography;
  const { queryResult } = useShow();
  const { data } = queryResult;
  const record = data?.data;


const {
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editModalShow,
} = useModalForm({
    action: "edit"
    , resource: 'publication'
    , redirect: false
});


  const extraContent = (
    <div>

        <Button 
            onClick={ ()=> editModalShow(id)}
        >Editar Publicación
        </Button>

        <a href={`${config.urlAPI}/publicar/publication/${id}`} target="_blank" rel="noreferrer">
            <Button>Generar Json</Button>
        </a>
        <a href={`${config.urlSitelibros}libros/${id}`} target="_blank" rel="noreferrer">
            <Button>Ver libro</Button>
        </a>
    </div>
  );




  return (
    <>
        <Title level={ 4 }>{ resourceLabel }: {record?record["pub_title"]:""}</Title>
        <Tabs defaultActiveKey="0" 
        tabBarExtraContent={extraContent}
        items={[
            {
                label: 'Publicación',
                key: '1',
                children: (<MenuPublication idPublication={id as any}></MenuPublication>)
            },
            // {
            //     label: 'General',
            //     key: '2',
            //     children: (<Cw8Edit resourceName={resourceName}childrenForms={childrenForms}></Cw8Edit>)
            // },
            {
                label: 'Secciones',
                key: '3',
                children: (<Cw8List
                    resourceName = {'sectionPub'}
                    filterList ={[
                        {
                            field: "sep_id_publication",
                            operator: "eq",
                            value: id
                        }
                    ]}
                    titleList = {"Secciones"}
                    showCards = {true}
                    createModal = {true}
                    editModal = {true}
                    configCard = {{
                        fieldTitle : "sep_title"
                    }}
                />)
            },
            {
                label: 'Autores',
                key: '4',
                children: (<Cw8List
                    resourceName = {'autorPublication'}
                    filterList ={[
                        {
                            field: "aup_id_publication",
                            operator: "eq",
                            value: id
                        }
                    ]}
                    titleList = {"Autores"}
                    showCards = {false}
                    createModal = {true}
                    editModal = {true}
                    configCard = {{
                        fieldTitle : "sep_title"
                    }}
                />)
            }            
        ]}></Tabs>

            <Modal {...editModalProps}
                title="Editar Publicación"
            >
                <Cw8Edit
                    key={id}
                    resourceName={'publication'}
                    editFormProps={editFormProps}
                    idResource={id}
                    modal={true}
                ></Cw8Edit>
            </Modal>

    </>
  )
}